export default __webpack_public_path__ + "static/media/matrix-labels-blue.8e3b55e1.svg";